module.exports = __webpack_public_path__ + "img/2021_2_11_heads_boy.8a4b4255.jpg";